bovoApp.controller('BovoAiController', ['$scope', '$http', '$filter', '$timeout', function ($scope, $http, $filter, $timeout) {
    $scope.chatbox = {
        isOpen: false,
        messages: [],
        currentMessage: '',
        isLoading: false,
        unreadCount: 0,
        conversationId: null
    };

    $scope.games = {
        isGameActive: false,
        currentGame: null,
        score: 0,
        gameTimer: null,
        cargoCount: {
            boxes: []
        }
    };

    $scope.startMiniGame = function () {
        if (!$scope.chatbox.isLoading) return;

        $scope.games.isGameActive = true;
        $scope.games.currentGame = 'cargoClick';
        $scope.games.score = 0;
        $scope.games.cargoCount.boxes = [];

        $scope.createNewCargo();
        $scope.animateCargoBoxes();

        $timeout(function () {
            var gameContainer = document.querySelector('.mini-game-container');
            if (gameContainer) {
                gameContainer.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
            scrollToBottom();
        }, 100);
    };

    $scope.createNewCargo = function () {
        if (!$scope.games.isGameActive) return;

        var cargoCount = Math.floor(Math.random() * 4) + 1;

        for (var i = 0; i < cargoCount; i++) {
            var size = 20 + Math.random() * 15;
            var newCargo = {
                id: Date.now() + Math.random() + i,
                x: Math.random() * (240 - size),
                y: -size - (i * 20),
                speed: 0.5 + Math.random() * 2.5,
                color: '#019e82',
                size: size,
                points: Math.floor(Math.random() * 5) + 1,
                rotation: Math.random() * 360,
                rotationSpeed: (Math.random() - 0.5) * 4
            };

            $scope.games.cargoCount.boxes.push(newCargo);
        }

        var nextCargoDelay = 500 + Math.random() * 1500;
        $timeout(function () {
            $scope.createNewCargo();
        }, nextCargoDelay);
    };

    $scope.animateCargoBoxes = function () {
        if (!$scope.games.isGameActive) return;

        $scope.games.cargoCount.boxes.forEach(function (box) {
            box.y += box.speed;
            box.rotation += box.rotationSpeed;

            if (Math.random() < 0.02) {
                box.x += (Math.random() - 0.5) * 2;
                if (box.x < 0) box.x = 0;
                if (box.x > (240 - box.size)) box.x = 240 - box.size;
            }
        });

        $scope.games.cargoCount.boxes = $scope.games.cargoCount.boxes.filter(function (box) {
            return box.y < 300;
        });

        $timeout(function () {
            $scope.animateCargoBoxes();
        }, 25);
    };

    $scope.clickCargo = function (cargo, index) {
        if (!$scope.games.isGameActive) return;

        $scope.games.score += cargo.points;

        $scope.games.cargoCount.boxes.splice(index, 1);

        var clickEffect = angular.element('<div class="click-effect">+' + cargo.points + '</div>');
        clickEffect.css({
            position: 'absolute',
            left: cargo.x + 'px',
            top: cargo.y + 'px',
            color: '#28a745',
            fontWeight: 'bold',
            fontSize: '14px',
            zIndex: 1000,
            pointerEvents: 'none'
        });

        angular.element('.game-area').append(clickEffect);

        $timeout(function () {
            clickEffect.remove();
        }, 1000);
    };

    $scope.endGame = function () {
        $scope.games.isGameActive = false;
        $scope.games.currentGame = null;
        $scope.games.cargoCount.boxes = [];

        if ($scope.games.gameTimer) {
            $timeout.cancel($scope.games.gameTimer);
        }

        if ($scope.games.score > 0) {
            var finalScore = angular.element('<div class="final-score">Toplam: ' + $scope.games.score + ' Puan!</div>');
            angular.element('.chatbox-messages').append(finalScore);
            $timeout(function () {
                finalScore.remove();
            }, 3000);
        }
    };

    function stopGameOnResponse() {
        if ($scope.games.isGameActive) {
            $scope.games.isGameActive = false;
            $scope.games.currentGame = null;

            if ($scope.games.gameTimer) {
                $timeout.cancel($scope.games.gameTimer);
            }
        }
    }

    $scope.toggleChatbox = function () {
        $scope.chatbox.isOpen = !$scope.chatbox.isOpen;

        if ($scope.chatbox.isOpen) {
            $scope.chatbox.unreadCount = 0;
            $timeout(function () {
                scrollToBottom();
            }, 100);
        }
    };

    $scope.sendQuickMessage = function (message) {
        $scope.chatbox.currentMessage = message;
        $scope.sendMessage();
    };

    $scope.sendMessage = function () {
        if (!$scope.chatbox.currentMessage.trim() || $scope.chatbox.isLoading) {
            return;
        }

        var userMessage = $scope.chatbox.currentMessage.trim();

        $scope.chatbox.messages.push({
            type: 'user',
            content: userMessage,
            timestamp: new Date()
        });

        $scope.chatbox.currentMessage = '';

        $scope.chatbox.isLoading = true;

        $timeout(function () {
            if ($scope.chatbox.isLoading) {
                $scope.startMiniGame();
            }
        }, 2000);

        $timeout(function () {
            scrollToBottom();
        }, 50);

        var requestData = {
            message: userMessage,
            conversation_id: $scope.chatbox.conversationId,
            _token: CSRF_TOKEN
        };

        $http.post('/api/bovo-ai-chat', requestData, {
            headers: {
                'Content-Type': 'application/json'
            },
            ignoreLoadingBar: true
        })
            .then(function (response) {
                $scope.chatbox.isLoading = false;

                stopGameOnResponse();

                if (response.data.success) {
                    $scope.chatbox.messages.push({
                        type: 'ai',
                        content: response.data.message,
                        timestamp: new Date()
                    });

                    if (response.data.conversation_id) {
                        $scope.chatbox.conversationId = response.data.conversation_id;
                    }

                    if (!$scope.chatbox.isOpen) {
                        $scope.chatbox.unreadCount++;
                    }
                } else {
                    // Hata mesajını göster
                    $scope.chatbox.messages.push({
                        type: 'ai',
                        content: 'Üzgünüm, bir hata oluştu. Lütfen tekrar deneyin: ' + (response.data.error || 'Bilinmeyen hata'),
                        timestamp: new Date()
                    });
                }

                $timeout(function () {
                    scrollToBottom();
                }, 100);
            })
            .catch(function (error) {
                $scope.chatbox.isLoading = false;

                stopGameOnResponse();

                var errorMessage = 'Bağlantı hatası oluştu. Lütfen internet bağlantınızı kontrol edin.';

                if (error.data && error.data.error) {
                    errorMessage = error.data.error;
                } else if (error.status === 401) {
                    errorMessage = 'Yetkilendirme hatası. Lütfen tekrar giriş yapın.';
                } else if (error.status === 500) {
                    errorMessage = 'Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.';
                }

                $scope.chatbox.messages.push({
                    type: 'ai',
                    content: errorMessage,
                    timestamp: new Date()
                });

                $timeout(function () {
                    scrollToBottom();
                }, 100);
            });
    };

    function scrollToBottom() {
        var messagesContainer = document.getElementById('chatbox-messages');
        if (messagesContainer) {
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }
    }

    $scope.handleKeyPress = function (event) {
        if (event.keyCode === 13 && !event.shiftKey) {
            event.preventDefault();
            $scope.sendMessage();
        }
    };

    $scope.trustAsHtml = function (content) {
        return content;
    };

    $scope.initBovoAi = function () {
        $scope.chatbox.isOpen = false;

        var savedConversation = localStorage.getItem('bovo_ai_conversation');
        if (savedConversation) {
            try {
                var parsed = JSON.parse(savedConversation);
                $scope.chatbox.conversationId = parsed.conversationId;
                $scope.chatbox.messages = parsed.messages || [];
            } catch (e) {
                localStorage.removeItem('bovo_ai_conversation');
            }
        }
    };

    function saveConversation() {
        var conversationData = {
            conversationId: $scope.chatbox.conversationId,
            messages: $scope.chatbox.messages.slice(-20) 
        };

        localStorage.setItem('bovo_ai_conversation', JSON.stringify(conversationData));
    }

    $scope.$watchCollection('chatbox.messages', function (newVal, oldVal) {
        if (newVal !== oldVal) {
            saveConversation();
        }
    });

    $scope.initBovoAi();
}]);

bovoApp.filter('trusted', ['$sce', function ($sce) {
    return function (html) {
        return $sce.trustAsHtml(html);
    };
}]);
